import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';

export const MY_REVIEWS_PAGE_COMPLETE_REQUEST = 'MY_REVIEWS_PAGE_COMPLETE_REQUEST';
export const MY_REVIEWS_PAGE_COMPLETE_SUCCESS = 'MY_REVIEWS_PAGE_COMPLETE_SUCCESS';
export const MY_REVIEWS_PAGE_COMPLETE_ERROR = 'MY_REVIEWS_PAGE_COMPLETE_ERROR';

export const MY_REVIEWS_PAGE_RECENT_REQUEST = 'MY_REVIEWS_PAGE_RECENT_REQUEST';
export const MY_REVIEWS_PAGE_RECENT_SUCCESS = 'MY_REVIEWS_PAGE_RECENT_SUCCESS';
export const MY_REVIEWS_PAGE_RECENT_ERROR = 'MY_REVIEWS_PAGE_RECENT_ERROR';

export const MY_REVIEWS_PAGE_DELETE_REQUEST = 'MY_REVIEWS_PAGE_DELETE_REQUEST';
export const MY_REVIEWS_PAGE_DELETE_SUCCESS = 'MY_REVIEWS_PAGE_DELETE_SUCCESS';
export const MY_REVIEWS_PAGE_DELETE_ERROR = 'MY_REVIEWS_PAGE_DELETE_ERROR';

export function myReviewsPageCompleteRequestAction() {
	return { type: MY_REVIEWS_PAGE_COMPLETE_REQUEST };
}

export function myReviewsCompleteSuccessAction(data) {
	return { type: MY_REVIEWS_PAGE_COMPLETE_SUCCESS, data };
}

export function myReviewsCompleteErrorAction(error) {
	return { type: MY_REVIEWS_PAGE_COMPLETE_ERROR, error };
}

const MY_REVIEW_COUNT = 5;

export function fetchMyReviewsCompletePageData(start = 1, count = MY_REVIEW_COUNT) {
	const reqQuery = {
		start: start,
		count: count
	};
	return dispatch => {
		dispatch(myReviewsPageCompleteRequestAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/completed/product',
				query: reqQuery
			})
		).then(
			data => dispatch(myReviewsCompleteSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(myReviewsCompleteErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function myReviewsPageRecentRequestAction() {
	return { type: MY_REVIEWS_PAGE_RECENT_REQUEST };
}

export function myReviewsRecentSuccessAction(data) {
	return { type: MY_REVIEWS_PAGE_RECENT_SUCCESS, data };
}

export function myReviewsRecentErrorAction(error) {
	return { type: MY_REVIEWS_PAGE_RECENT_ERROR, error };
}

export function fetchMyReviewsRecentPageData(start = 1, count = MY_REVIEW_COUNT) {
	const reqQuery = {
		start: start,
		count: count
	};
	return dispatch => {
		dispatch(myReviewsPageRecentRequestAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/unsolicited',
				query: reqQuery
			})
		).then(
			data => dispatch(myReviewsRecentSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(myReviewsRecentErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function myReviewsPageDeleteRequestAction() {
	return { type: MY_REVIEWS_PAGE_DELETE_REQUEST };
}

export function myReviewsDeleteSuccessAction(data) {
	return { type: MY_REVIEWS_PAGE_DELETE_SUCCESS, data };
}

export function myReviewsDeleteErrorAction(error) {
	return { type: MY_REVIEWS_PAGE_DELETE_ERROR, error };
}

export function fetchMyReviewsDeletePageData(reviewId) {
	return dispatch => {
		dispatch(myReviewsPageDeleteRequestAction());
		return ApiCaller.delete(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/3/reviews?id=${reviewId}&type=PRODUCT`
			})
		).then(
			data => dispatch(myReviewsDeleteSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(myReviewsDeleteErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
